module.exports = __webpack_public_path__ + "img/group_Team_Roster.73da241a.svg";